"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return Array.from(Array(n).keys());
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/array/sequence.js
// module id = 48
// module chunks = 0